const SPECIAL_SLUGS: Record<string, string> = { 'Do Not Disturb': 'dnd' };

export const slugOf = (name: string) =>
  SPECIAL_SLUGS[name] ?? name.toLowerCase().replace(/\s+/g, '-');

export const MODE_COLORS: Record<string, string> = {
  gaming: '#ff3b30',
  fitness: '#34c759',
  reading: '#ff9500',
  learning: '#007aff',
  dnd: '#a6a6a6',
  work: '#cfcfcf',
  sleep: '#828282',
};

export const MODE_LABELS: Record<string, string> = {
  gaming: 'Gaming',
  fitness: 'Fitness',
  reading: 'Reading',
  learning: 'Learning',
  dnd: 'Do Not Disturb',
  work: 'Work',
  sleep: 'Sleep',
};

export const colorOf = (name: string) => MODE_COLORS[slugOf(name)] ?? '#666';

export const labelOf = (name: string) => MODE_LABELS[slugOf(name)] ?? name;
